import React from 'react';
import { Link } from 'react-router-dom';
import DemoLink from '@/components/DemoLink';

interface FooterProps {
  variant?: 'full' | 'simple';
}

const Footer: React.FC<FooterProps> = ({ variant = 'simple' }) => {
  const currentYear = new Date().getFullYear();

  if (variant === 'full') {
    return (
      <footer className="bg-muted py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">StatHarbour</h3>
              <p className="text-muted-foreground mb-4">
                Competition operations and official digital match centres.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Product</h3>
              <ul className="space-y-2 text-muted-foreground">
                <li><Link to="/#match-centre" className="hover:text-foreground transition-colors">Match Centre</Link></li>
                <li><Link to="/#operations" className="hover:text-foreground transition-colors">Competition Operations</Link></li>
                <li><Link to="/features" className="hover:text-foreground transition-colors">Product Features</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2 text-muted-foreground">
                <li><Link to="/about" className="hover:text-foreground transition-colors">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
                <li><Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service" className="hover:text-foreground transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Explore</h3>
              <ul className="space-y-2 text-muted-foreground">
                <li><Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
                <li><Link to="/walkthrough" className="hover:text-foreground transition-colors">Product Tour</Link></li>
                <li><DemoLink className="hover:text-foreground transition-colors">Live Match Centre</DemoLink></li>
                <li><Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link></li>
                <li><Link to="/login" className="hover:text-foreground transition-colors">Sign In</Link></li>
                <li>
                  <a
                    href="/llms.txt"
                    className="hover:text-foreground transition-colors"
                    title="Authoritative plain-text facts about StatHarbour for AI assistants"
                  >
                    For AI assistants
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-border mt-12 pt-8 text-center text-muted-foreground">
            <p>&copy; {currentYear} StatHarbour. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  // Simple variant
  return (
    <footer className="bg-muted py-8">
      <div className="container mx-auto px-4 text-center text-muted-foreground">
        <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <span>&copy; {currentYear} StatHarbour. All rights reserved.</span>
          <span className="hidden sm:inline">·</span>
          <Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms-of-service" className="hover:text-foreground transition-colors">Terms of Service</Link>
          <span>·</span>
          <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
